import { defineMessages } from 'react-intl'

const scope = 'containers.AdSheetImportPage'

export default defineMessages({
  title: { id: `${scope}.title`, defaultMessage: 'Import from AD sheet' },
  intro: {
    id: `${scope}.intro`,
    defaultMessage: 'In the AD sheet, select rows in Titles and choose 🎬 AD Dashboard → 📤 Export. Upload the CSV here: every title becomes one order with a job per language (Studio, author and QC tasks).',
  },
  chooseFile: { id: `${scope}.chooseFile`, defaultMessage: 'Choose CSV' },
  reading: { id: `${scope}.reading`, defaultMessage: 'Reading…' },
  customer: { id: `${scope}.customer`, defaultMessage: 'Customer' },
  customerDescription: { id: `${scope}.customerDescription`, defaultMessage: 'All imported orders go to this customer' },
  contact: { id: `${scope}.contact`, defaultMessage: 'Contact' },
  contactDescription: { id: `${scope}.contactDescription`, defaultMessage: 'All imported orders go to this contact' },
  search: { id: `${scope}.search`, defaultMessage: 'Search…' },
  po: { id: `${scope}.po`, defaultMessage: 'PO number' },
  trailer: { id: `${scope}.trailer`, defaultMessage: 'Trailer' },
  fullTitle: { id: `${scope}.fullTitle`, defaultMessage: 'Full title' },
  sheetRows: { id: `${scope}.sheetRows`, defaultMessage: 'Titles rows {rows}' },
  existingOrder: { id: `${scope}.existingOrder`, defaultMessage: 'Existing order' },
  language: { id: `${scope}.language`, defaultMessage: 'Language' },
  due: { id: `${scope}.due`, defaultMessage: 'Due' },
  status: { id: `${scope}.status`, defaultMessage: 'Sheet status' },
  author: { id: `${scope}.author`, defaultMessage: 'Author' },
  qc: { id: `${scope}.qc`, defaultMessage: 'QC' },
  cost: { id: `${scope}.cost`, defaultMessage: 'Cost €' },
  noSupplier: { id: `${scope}.noSupplier`, defaultMessage: 'No supplier (assign later)' },
  remembered: { id: `${scope}.remembered`, defaultMessage: 'Remembered from a previous import' },
  alreadyIn: { id: `${scope}.alreadyIn`, defaultMessage: 'Already in order #{orderId}' },
  warnings: { id: `${scope}.warnings`, defaultMessage: 'Rows the file could not use' },
  importButton: { id: `${scope}.importButton`, defaultMessage: 'Create {count, plural, one {# order} other {# orders}}' },
  importing: { id: `${scope}.importing`, defaultMessage: 'Creating orders…' },
  nothingToImport: { id: `${scope}.nothingToImport`, defaultMessage: 'Every row in this file is already in an order.' },
  created: { id: `${scope}.created`, defaultMessage: 'Orders created' },
  pasteLink: { id: `${scope}.pasteLink`, defaultMessage: 'Paste the link into column K of Titles row {row}' },
  copyLink: { id: `${scope}.copyLink`, defaultMessage: 'Copy link' },
  copied: { id: `${scope}.copied`, defaultMessage: 'Copied' },
  skipped: { id: `${scope}.skipped`, defaultMessage: 'Skipped' },
  errors: { id: `${scope}.errors`, defaultMessage: 'Could not create' },
  startOver: { id: `${scope}.startOver`, defaultMessage: 'Import another file' },
  priceNote: {
    id: `${scope}.priceNote`,
    defaultMessage: 'The customer price on each Studio task is left blank: set it on the order before invoicing.',
  },
})
